import React, { useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GalleryHero from "./components/GalleryHero";
import VirtualTourSection from "./components/VirtualTourSection";
import LightingMoodSection from "./components/LightingMoodSection";
import SeatingAreasSection from "./components/SeatingAreasSection";
import CustomerMomentsSection from "./components/CustomerMomentsSection";
import SpecialEventsSection from "./components/SpecialEventsSection";

const AmbienceGallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <Header />

      <main className="main-content">
        <GalleryHero />
        <VirtualTourSection />
        <LightingMoodSection />
        <SeatingAreasSection />
        <CustomerMomentsSection />
        {/* <SpecialEventsSection /> */}
      </main>

      <Footer />
    </div>
  );
};

export default AmbienceGallery;
